import React from "react";
import classnames from "classnames";
import Language from "../language/language";
import { withRouter } from "react-router-dom";
import ReactGA from "react-ga";
import moment from "moment";
import { inject, observer } from "mobx-react";
import { $const, $util } from "../../helper";
import MessageBox from "element-react/dist/npm/es5/src/message-box";
import "./stylesheets/game.scss";

@inject("languageStore", "gameStore", "authStore", "teamStore", "personGameStore", "commonStore")
@withRouter
@observer
export default class GameCard extends React.Component {
  // 报名/加入战队/未开始/已开始/已结束展示
  lastTime = game => {
    // 是否是“机甲大师高校联盟赛”或”机甲大师超级对抗赛“
    const isSpecialGame = this.props.gameStore.showTeamSloganGameCategoryId.includes(
      `${game.attributes.category_id}`
    );

    let begin = undefined;
    let end = undefined;
    game.attributes &&
      game.attributes.flows &&
      game.attributes.flows.length > 0 &&
      game.attributes.flows.forEach(flow => {
        if (
          flow &&
          flow.attributes &&
          flow.attributes.stages &&
          flow.attributes.stages.length > 0
        ) {
          flow.attributes.stages.forEach(node => {
            // 报名环节 就是第一个环节
            // 通过获取报名环节的开始、结束时间来确认展示可操作选项
            if (node.attributes.major_num === 0) {
              if (!begin || moment(node.attributes.begin_at) < moment(begin)) {
                begin = node.attributes.begin_at;
              }
              if (!end || moment(node.attributes.end_at) > moment(end)) {
                end = node.attributes.end_at;
              }
            }
          });
        }
      });
    if (!begin || !end) {
      return "";
    }
    let fTime = "";
    let time = "";
    let operate;
    let isNotBegin = false;
    if (game.attributes.category.event_type === 999) {
      operate = "JOIN_A_DELIVERY";
    }
    // 如果结束时间已经超过了当前时间，那么看是否可以加入战队
    else if (moment(end) < moment()) {
      // 团体赛 lockStatus true 锁定状态 false 放开状态
      if (
        game.attributes.category &&
        game.attributes.category.registration_source_type === $const.EVENT_TYPE.TEAM &&
        game.attributes.lock_status === false &&
        !isSpecialGame
      ) {
        // 开放可以加入战队
        operate = "JOIN_A_TEAM";
      } else {
        time = <Language resource="IS_END" />;
      }
    } else if (moment(begin) > moment()) {
      time = <Language resource="NOT_BEGIN" />;
      isNotBegin = true;
    } else {
      fTime = moment(end).diff(moment(), "hours");
      time = `${parseInt(fTime / 24, 10)}${
        this.props.languageStore.lang === "zh" ? "天" : "days"
      } ${fTime % 24}${this.props.languageStore.lang === "zh" ? "小时" : "hours"}`;
      operate = "APPLY_NOW";
    }

    const bbsHasTeamManagement = this.props.authStore.bbsHasTeamManagement;

    return [
      time && !isNotBegin && (
        <Language
          className="remaining"
          key="REGISTRATION_TIME_REMAINING"
          resource="REGISTRATION_TIME_REMAINING"
        />
      ),
      isNotBegin && (
        <div>
          <Language
            className="remaining"
            key="REGISTRATION_TIME_BEGIN"
            resource="REGISTRATION_TIME_BEGIN"
          />
          <div className="remaining">
            {this.props.languageStore.lang === "zh"
              ? moment(begin).format("YYYY年MM月DD日 HH:mm:ss")
              : moment(begin).format("LLLL")}
          </div>
        </div>
      ),
      <div key="last-time" className="last-time">
        {time}
      </div>,
      <div key="operate">
        {operate ? (
          <div key="operate" className="operate">
            {isSpecialGame && !bbsHasTeamManagement ? (
              // 特殊比赛（“机甲大师高校联盟赛”或”机甲大师超级对抗赛“）且论坛无管理权限的点击报名以后弹框提示
              <div className="button" onClick={this.showApplyTipsBBS}>
                <Language resource={operate} />
              </div>
            ) : (
              <div className="button" onClick={this.showGameTerm.bind(this, operate)}>
                <Language resource={operate} />
              </div>
            )}
          </div>
        ) : null}
      </div>
    ];
  };

  showApplyTipsBBS = () => {
    this.props.teamStore.setApplyTipsBBSState(true);
  };

  goToPerson = () => {
    window.location.href = $util.getPersonCenterUrl(this.props.languageStore.lang);
  };

  // 展示条款
  showGameTerm = joinType => {
    ReactGA.event({
      category: "Recruit_Sign_Up",
      action: "Click",
      label: this.props.data.attributes.title
    });
    this.props.commonStore.gTag("event", "showGameTerm", {
      pageName: "registrationCenter",
      competitionName: this.props.data.attributes.title
    });
    this.props.commonStore.gTag("event", "recruitSignUp", {
      pageName: "registrationCenter",
      competitionName: this.props.data.attributes.title
    });
    const { birthday = null } = this.props.authStore.user;
    const { birthday_begin_at: birthdayBeginAt = null, birthday_end_at: birthdayEndAt = null } =
      this.props.data.attributes || {};
    let varStr = "";
    const birthdayTime = new Date(birthday).getTime();
    const birthdayBeginAtTime = new Date(birthdayBeginAt).getTime();
    const birthdayEndAtTime = new Date(birthdayEndAt).getTime();

    const birthdayBeginAtStr = $util.formatDate("yyyy-MM-dd", birthdayBeginAt);
    const birthdayEndAtStr = $util.formatDate("yyyy-MM-dd", birthdayEndAt);

    // 年龄校验
    if (
      birthdayBeginAt &&
      birthdayEndAt &&
      (birthdayTime < birthdayBeginAtTime || birthdayTime > birthdayEndAtTime)
    ) {
      varStr =
        this.props.languageStore.lang === "zh"
          ? `在 ${birthdayBeginAtStr}（包含）至 ${birthdayEndAtStr}（包含）`
          : ` with birth dates from ${birthdayBeginAtStr} (inclusive) to ${birthdayEndAtStr} (inclusive)`;
    } else if (!birthdayBeginAt && birthdayEndAt && birthdayTime > birthdayEndAtTime) {
      varStr =
        this.props.languageStore.lang === "zh"
          ? ` ${birthdayEndAtStr}（包含）前出生`
          : ` who are born before ${birthdayEndAtStr} (inclusive)`;
    } else if (birthdayBeginAt && !birthdayEndAt && birthdayTime < birthdayBeginAtTime) {
      varStr =
        this.props.languageStore.lang === "zh"
          ? ` ${birthdayBeginAtStr}（包含）后出生`
          : ` who are born after ${birthdayBeginAtStr} (inclusive)`;
    }

    // 如果年龄校验不通过，拼接年龄校验字符串
    if (varStr) {
      return this.props.languageStore.lang === "zh"
        ? MessageBox.alert(
            <div>
              该比赛仅允许出生日期{varStr}的同学参加，如您的资料有误，您可在
              <span className="spe-link" onClick={this.goToPerson}>
                个人中心
              </span>
              修改个人信息。
              <p>请注意：我们将在比赛现场核验身份，违者将取消参赛资格。</p>
            </div>,
            "年龄限制提醒"
          )
        : MessageBox.alert(
            <div>
              This competition only allows students {varStr} to participate. If your information is
              incorrect, you can modify your personal information in the{" "}
              <span className="spe-link" onClick={this.goToPerson}>
                Personal Center
              </span>
              .
              <p>
                Please attention: we will verify your identity on the competition site and violators
                will be disqualified.
              </p>
            </div>,
            "Age Restriction",
            { confirmButtonText: "Confirm" }
          );
    }

    let event = this.props.data;
    let eventId = event.id;
    let slug = true; // slug为检查用户是否可以弹出条款窗口的标记，已报名了赛事则为false，未报名则为true

    // 如果是团队赛，那么检查是不是已经报名了
    if (
      event &&
      event.attributes &&
      event.attributes.category &&
      event.attributes.category.registration_source_type === $const.EVENT_TYPE.TEAM
    ) {
      this.props.teamStore.myTeams.length > 0 &&
        this.props.teamStore.myTeams.forEach(item => {
          // 有队伍
          if (item.gevent.id === eventId) {
            if (item.precheck === $const.CLICK_APPLY_GAME.YES) {
              this.props.history.push(`/game-apply-info/${item.id}`);
            } else {
              this.props.history.push(`/team-apply/${item.id}`);
            }
            slug = false;
            return;
          }
        });

      // 如果用户未被同意申请战队，依旧跳转到申请成功页面
      this.props.teamStore.myApplication.length > 0 &&
        this.props.teamStore.myApplication.forEach(item => {
          // 有注册
          if (
            item.status === $const.TEAM_APPLICATION_STATUS.PENDING &&
            item.team &&
            item.team.gevent &&
            item.team.gevent.id === eventId
          ) {
            this.props.teamStore.setApplicationTeamInfo(
              {
                id: item.team.id,
                collegeName: item.team.collegeName,
                name: item.team.name
              },
              {
                gappliction: {
                  id: item.id,
                  teamId: item.team.id
                },
                eventRoleId: item.eventRoleId,
                eventPositionId: item.eventPositionId
              }
            );
            slug = false;
            this.props.history.push("apply-team-success");
            return;
          }
        });
    }

    // 如果是个人赛，那么跳转到报名记录的地址
    if (
      event &&
      event.attributes &&
      event.attributes.category &&
      event.attributes.category.registration_source_type === $const.EVENT_TYPE.PERSON
    ) {
      this.props.personGameStore.myEvents &&
        this.props.personGameStore.myEvents.forEach(item => {
          if (item.eventId === eventId) {
            slug = false;
            this.props.history.push(`/personGame-apply-info/${item.id}`);
            return;
          }
        });
    }

    if (slug) {
      if (this.props.authStore.userIsOk) {
        // 用户满足检查前置条件，获取比赛条款并展示
        this.props.gameStore.getEventLicense(this.props.data.id).then(() => {
          this.props.gameStore.showGameTerm(
            this.props.data.id,
            this.props.gameStore.license,
            joinType
          );
        });
      } else {
        // 用户不满足检查前置条件
        this.props.authStore.showUserNotice(this.props.data, this.props.data.attributes.title);
      }
    }
  };

  applyNow = () => {
    this.props.commonStore.gTag("event", "applyNow", {
      pageName: "registrationCenter",
      competitionName: this.props.data.attributes.title,
      buttonName: "立即报名"
    });
  };

  render() {
    let game = this.props.data;
    let time = this.lastTime(game);
    let currentGameId = this.props.gameStore.currentGameId;

    return game && game.attributes && game.attributes.title ? (
      <div className={classnames("game-card", currentGameId === game.id ? "active" : "")}>
        <div className="inner-game-card">
          <div className="game-logo">
            <img
              src={
                $util.getSafePicUrl(game.attributes.img_url)
                  ? $util.getSafePicUrl(game.attributes.img_url)
                  : "https://rm-static.djicdn.com/robomasters/public/img/live-chatroom-input-icon.c6009a6.png"
              }
              alt={game.attributes.title}
            />
          </div>
          <div className="game-info">
            <div className="title">{game.attributes.title}</div>
            <p className="time-info">{game.attributes.duration ? game.attributes.duration : ""}</p>
            <div className="desc">
              {game.attributes.summary && game.attributes.summary.substr(0, 95)}
              {game.attributes.detail_url ? (
                <a className="view-more" href={game.attributes.detail_url} target="_blank">
                  <Language resource="VIEW_MORE" />
                </a>
              ) : null}
            </div>
          </div>
          <div className="game-operate">
            <div className="operates" onClick={this.applyNow}>
              {time}
            </div>
          </div>
        </div>
      </div>
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./src/components/game/gameCardV2.js